module.exports = __webpack_public_path__ + "static/img/img_background_pc.9c08726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/bsop/img_background_pc.jpg
// module id = F5LU
// module chunks = 0